module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJ1JREFUOE+Vk4sNgCAMRM/NZDJlMhlNztikQg+BxAQl79kfG4AdwAEgYW2dlS1bZbihoCxIrvfHiQKuFYnBmZwJZiUfmJAX/Ek6OBIoSQgrQSvhOzv15Nw2qk3Bn1th+S2ERxHwzMLmXrZYReBzpkDOSSSICibnpBXIaqth84IRbMXtIjHBDBxK/GWSrQouqUWSKeCQ8OmG5Od2k8ENZAk0UQKjw/8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 2